import { FC, ReactNode } from 'react';
import TaxLimit from 'modules/Deposit/components/TaxLimit';
import successIcon from 'static/images/icons/contributionComplete.png';
import classlist from 'utils/classlist';
import style from './style.scss';

interface ContributionSuccessProps {
    year: string;
    cost?: number;
    className?: string;
    extra?: ReactNode;
}

const ContributionSuccess: FC<ContributionSuccessProps> = ({ year, cost, className, extra }) => {
    return (
        <div className={classlist(style.root, className)}>
            <img src={successIcon} alt="success" className={style.icon} />
            <div className={style.content}>
                <div>{__('Success!')}</div>
                <div>{__('Your contribution has been initiated.')}</div>
            </div>
            <TaxLimit successYear={year} cost={cost} />
            {extra && <div className={style.extra}>{extra}</div>}
        </div>
    );
};

export default ContributionSuccess;
